import { onMounted, onBeforeUnmount, ref } from "vue";

export function useAnimateOnVisible(animationClass: string) {
  const element = ref<HTMLElement | null>(null);

  let observer: IntersectionObserver | null = null;

  onMounted(() => {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate__animated", animationClass);
            observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (element.value) {
      observer.observe(element.value);
    }
  });

  onBeforeUnmount(() => {
    if (observer && element.value) {
      observer.unobserve(element.value);
    }
  });

  return element;
}
